import { Box, Button, Center, Text } from "@chakra-ui/react";
import { CalendarFilter } from "components/atendimentos-components/attendance-filter/calendar-filter";
import { DropdownOptionProps } from "components/dropdown";
import { NewDropdown } from "components/dropdown/new-dropdown";
import { Popover } from "components/popover";
import { Toast } from "components/toast";
import { Filter2Icon } from "components/vectors/filter-icon";
import { useEffect, useState } from "react";
import { PropostasFilterProps } from "../utils";
import { dropdownBancosDigitacao } from "components/usuarios-bancos-components/consts";
import { apiJWT } from "api/api-jwt";

export function PropostasFilter({
  onChange,
  isLoading,
  filter,
  errors,
  onSearch
}: {
  onChange: (
    value: any,
    key: keyof PropostasFilterProps,
    params?: {
      update: boolean;
    }
  ) => void;
  isLoading: boolean;
  filter: PropostasFilterProps;
  errors: { [k: string]: string };
  onSearch: (currentFilter?: PropostasFilterProps) => Promise<void>;
}) {
  const [usersList, setUsersList] = useState<DropdownOptionProps[]>([]);
  const [isLoadingUsers, setIsLoadingUsers] = useState(false);
  const withErrors = !!Object.keys(errors).length;
  const getUsers = async () => {
    setIsLoadingUsers(true);
    try {
      const { data } = await apiJWT.get(
        "/usuarios/possible-transfer-attendance"
      );
      setUsersList([
        { name: "Todos", value: undefined },
        ...data.map((user: any) => ({ name: user.name, value: user.id }))
      ]);
    } catch (e) {
      Toast({ title: "Erro ao carregar usuários!", status: "error" });
    } finally {
      setIsLoadingUsers(false);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  const dropdownTiposOperacao = [
    { name: "Novo", value: "NOVO" },
    { name: "Refinanciamento", value: "REFIN" },
    { name: "Portabilidade", value: "PORTABILIDADE" },
    { name: "Cartão Novo RMC", value: "CARTAO_NOVO_RMC" },
    { name: "Cartão Novo RCC", value: "CARTAO_NOVO_RCC" },
    { name: "Saque Complementar RMC", value: "SAQUE_COMPLEMENTAR_RMC" },
    { name: "Saque Complementar RCC", value: "SAQUE_COMPLEMENTAR_RCC" }
  ];

  const parseTipoOperacao = (value: String) => {
    if (!value) return value;
    return dropdownTiposOperacao.filter((f) => f.value === value)[0].name;
  };

  const parseBanco = (value: string) => {
    if (!value) return value;
    return dropdownBancosDigitacao.filter((f) => f.value === value)[0].name;
  };

  return (
    <Popover
      button={
        <Button
          variant="ghost"
          alignItems="center"
          cursor="pointer"
          _hover={{ bg: "gray.200" }}
          px="10px"
          borderRadius="10px"
          leftIcon={<Filter2Icon />}
          fontSize="14px"
          fontWeight="medium"
          pos="relative"
        >
          Filtrar por
          {Object.keys(filter).length - 3 ? (
            <Center
              rounded="full"
              bg="red"
              color="white"
              w="14px"
              h="14px"
              fontSize="10px"
              pos="absolute"
              top="-5px"
              right="-5px"
            >
              {Object.keys(filter).length - 3}
            </Center>
          ) : null}
        </Button>
      }
      title="Filtrar por"
      position="left-bottom"
      withOutCloseButton
      popupStyles={{ minWidth: "320px" }}
      contentProps={{ padding: "0px" }}
    >
      {({ onClose }) => (
        <>
          <Box overflow="auto" maxHeight="300px" padding="8px">
            <Box mb="20px">
              <Text fontSize="14px" fontWeight="medium" mb="8px">
                Usuário
              </Text>
              <NewDropdown
                maxH={150}
                isLoading={isLoadingUsers}
                options={usersList}
                onChange={(option) =>
                  onChange(option.value, "userIdDigitador", { update: false })
                }
                value={filter.userIdDigitador}
                isDisabled={isLoading}
                placeholderRender={(value) =>
                  usersList.find(({ value: v }) => v === value)?.name ?? value
                }
              />
            </Box>
            <Box mb="20px">
              <Text fontSize="14px" fontWeight="medium" mb="8px">
                Tipo Operação
              </Text>
              <NewDropdown
                options={[
                  { name: "Todos", value: undefined },
                  ...dropdownTiposOperacao
                ]}
                value={parseTipoOperacao(filter.operacao!)}
                onChange={(option) => {
                  onChange(option.value, "operacao", { update: false });
                }}
                isDisabled={isLoading}
              />
            </Box>
            <Box mb="20px">
              <Text fontSize="14px" fontWeight="medium" mb="8px">
                Banco
              </Text>
              <NewDropdown
                options={[
                  { name: "Todos", value: undefined },
                  ...dropdownBancosDigitacao
                ]}
                value={parseBanco(filter.banco!)}
                onChange={(option) => {
                  onChange(option.value, "banco", { update: false });
                }}
                isDisabled={isLoading}
              />
            </Box>
            <Box mb="20px">
              <Text mb="8px" fontWeight="medium">
                Data de criação
              </Text>
              <CalendarFilter
                onChange={(v, k) => onChange(v, k, { update: false })}
                filter={filter}
                keyDataInicio="dataInicio"
                keyDataFim="dataFim"
                leftInputProps={{ errorMessage: errors["dataInicio"] }}
                rightInputProps={{ errorMessage: errors["dataFim"] }}
              />
            </Box>
          </Box>

          <Box padding="8px">
            <Button
              w="100%"
              size="lg"
              fontSize="14"
              borderRadius="10px"
              onClick={() => {
                if (!withErrors) {
                  onSearch();
                  onClose();
                }
              }}
            >
              Aplicar
            </Button>
          </Box>
        </>
      )}
    </Popover>
  );
}
